import {
  saveLocalStorWHStockUpdateMsgList, 
  cleanLocalStorWHStockUpdateMsgList, 
  getLocalStorWHStockUpdateMsgList,
  saveLocalStorWHStockUpdateHisMsgList,
  getLocalStorWHStockUpdateHisMsgList,
} from '@/utils/localStorageCommon'
export default {
  namespaced: true,
  state: {
    websocketObj: null,
    /**
     * cmd：
     * 关闭socket连接：socket-connect-close
     * 供应商自己库存导入进度：wh-stock-import-rate
     * 供应商退出登录：wh-logout
     */
    warehouseLogout: 0, // 供应商退出登录出发项
    whsuMsgList: [], // 数目上传、更新库存消息 {specialLabel:消息批次随机数标签，batch：批次号，onMsgList：数据}
    whsuMsgHisList: [], // 数目上传、更新库存消息 {specialLabel:消息批次随机数标签，batch：批次号，onMsgList：history数据}

    whBatchAutoEnd: 0,
    whBatchIsbnEnd: 0,
    whBatchProdectNameEnd: 0,
    whBatchAutoMsgList: [], //通用自动批量查单
    whBatchIsbnMsgList: [], //isbn批量查单
    whBatchProductMsgList: [], //书名批量查单
  },
  mutations: {
    udpateOrderTeamsInfoMap: (state) => {
      state.warehouseLogout = new Date().getTime()
    },
    warehouseBarchOrderMsg: (state, msg) => {
      // console.log('msgInfo',msg.step, msg.msg, msg)
      if (msg.step == 3 && msg.type == 'auto') {
        state.whBatchAutoEnd = new Date().getTime()
      } else if(msg.step == 3 && msg.type == 'isbn'){
        state.whBatchIsbnEnd = new Date().getTime()
      } else if(msg.step == 3 && msg.type == 'productName'){
        state.whBatchProdectNameEnd = new Date().getTime()
      }
      if (msg.step == 1) {
        state.whBatchAutoMsgList = []
        state.whBatchAutoMsgList.length = 0
        state.whBatchIsbnMsgList = []
        state.whBatchIsbnMsgList.length = 0
        state.whBatchProductMsgList = []
        state.whBatchProductMsgList.length = 0
      }
      // 添加缓存的进度信息-最上边
      // 上传批次
      if (msg.type == 'auto') {
        let lf = false;
        if (state.whBatchAutoMsgList && state.whBatchAutoMsgList.length > 0) {
          state.whBatchAutoMsgList.forEach((item) => {
            if (msg.step === item.step && msg.type === item.type) {
              // 同一组消息
              lf = true;
              item = msg
            }
          })
        }
        if (!lf) {
          state.whBatchAutoMsgList.push(msg)
        }
      } else if(msg.type == 'isbn'){
        let lf = false;
        if(state.whBatchIsbnMsgList && state.whBatchIsbnMsgList.length > 0){
          state.whBatchIsbnMsgList.forEach((item) => {
            if(msg.step === item.step && msg.type === item.type){
              // 同一组消息
              lf = true;
              item = msg
            }
          })
        }
        if(!lf){
          state.whBatchIsbnMsgList.push(msg)
        }
      } else if(msg.type == 'productName'){
        let lf = false;
        if(state.whBatchProductMsgList && state.whBatchProductMsgList.length > 0){
          state.whBatchProductMsgList.forEach((item) => {
            if(msg.step === item.step && msg.type === item.type){
              // 同一组消息
              lf = true;
              item = msg
            }
          })
        }
        if(!lf){
          state.whBatchProductMsgList.push(msg)
        }
      }
    },

    warehouseStockUpdateMsgLS_TO_ST(state){
      // 从本地缓存迁移进度信息到store
      var list = getLocalStorWHStockUpdateMsgList(null)
      state.whsuMsgList = list
      var hisList = getLocalStorWHStockUpdateHisMsgList(null)
      state.whsuMsgHisList = hisList
    },
    warehouseStockUpdateMsg: (state, msg) => {
      // console.log('msgInfo',msg.step, msg.msg, msg)
      // 添加缓存的进度信息-最上边
      // 上传批次
      var lf = false;
      state.whsuMsgList.forEach((item) => {
        if(msg.specialLabel === item.specialLabel && msg.batch === item.batch){
          // 同一组消息
          lf = true;
          item.onMsgList.push(msg)
          // var df = false;
          // item.onMsgList.forEach((dataItem) => {
          //   if(dataItem.threadId === msg.threadId && msg.threadId != '0'){
          //     df = true; // 存在同一个线程的消息
          //     if(dataItem.timeFlag <= msg.timeFlag && dataItem.step < msg.step){
          //       dataItem.msgTime = msg.msgTime
          //       dataItem.timeFlag = msg.timeFlag
          //       dataItem.step = msg.step
          //       dataItem.msg = msg.msg
          //       dataItem.id = msg.id
          //       dataItem.timestampToken = new Date().getTime()
          //     }
          //   }
          // })
          // if(!df){
          //   item.onMsgList.unshift(msg)
          // }
        }
      })
      if(!lf){
        var msgChList = []
        msgChList.push(msg)
        var oJson = {
          specialLabel: msg.specialLabel,
          batch: msg.batch,
          onMsgList: msgChList,
        }
        state.whsuMsgList.unshift(oJson)
      }
      saveLocalStorWHStockUpdateMsgList(state.whsuMsgList, null)

      // 历史消息
      var hf = false;
      state.whsuMsgHisList.forEach((item) => {
        if(msg.specialLabel === item.specialLabel && msg.batch === item.batch){
          // 同一组消息
          hf = true;
          item.onMsgList.push(msg)
        }
      })
      if(!hf){
        var msgHisChList = []
        msgHisChList.push(msg)
        var oHisJson = {
          specialLabel: msg.specialLabel,
          batch: msg.batch,
          onMsgList: msgHisChList,
        }
        state.whsuMsgHisList.unshift(oHisJson)
      }
      saveLocalStorWHStockUpdateHisMsgList(state.whsuMsgHisList, null)
      
    },
    cleanWarehouseStockUpdateMsgList: (state) => {
      // 清空缓存的进度信息
      state.whsuMsgList = []
      state.whsuMsgHisList = []
      cleanLocalStorWHStockUpdateMsgList(null)
    },
    opeartionWebsocketClose(state){ 
      if (state.websocketObj) {
        state.websocketObj.close()
      }
    },
  },
  actions: {
    /**
     * 接受java推送的socket消息
     * {cmd， uTp}
     * @param {*} param0 
     * @param {*} msg 
     */
    receiveMsg({commit}, msg) {
      // console.log('[socket.js.receiveMsg()] 获取到java后台推送到前端的socket消息', msg.cmd, msg);
      switch (msg.cmd) {
        case "wh-logout": // 供应商退出登录
          commit('udpateOrderTeamsInfoMap')
          break;
        case "users-logout": // 用户退出登录
          commit('udpateOrderTeamsInfoMap')
            break;
        // case "socket-connect-close": // 关闭连接
        //   break;
        case "wh-stock-import-rate": // 供应商自己库存导入进度
          commit('warehouseStockUpdateMsg', msg)
          break;
        case "wh-batch-order-rate": // 供应商查单进度
          commit('warehouseBarchOrderMsg', msg)
          break;
      }
    },
  },
  getters: {},
  modules: {},
};
